import React from "react";
const DropboxAttachmentIcon = React.forwardRef((props, svgRef) => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    ref={svgRef}
    {...props}
  >
    <title>dropbox</title>
    <g
      id="dropbox"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M20.0921347,24.008575 L27.8395503,30.27443 L31.1483001,28.1718809 L31.1483001,30.5341391 L20.0921347,37 L9.01571992,30.5341391 L9.01571992,28.1718809 L12.3447192,30.27443 L20.0921347,24.008575 Z M8.66540552,16.0123211 L19.8035809,22.71799 L12.0764148,28.983845 L1,21.8970704 L8.66540552,16.0123211 Z M31.3548439,16.0123211 L39,21.9776698 L27.964084,28.983845 L20.2369178,22.71799 L31.3548439,16.0123211 Z M12.0764148,3 L19.8035809,9.26585501 L8.66540552,15.9715239 L1,9.94547689 L12.0764148,3 Z M27.964084,3 L39,10.0061752 L31.3548439,15.9715239 L20.2369178,9.26585501 L27.964084,3 Z"
        fill="#007EE5"
      ></path>
    </g>
  </svg>
));
DropboxAttachmentIcon.displayName = "DropboxAttachmentIcon";
export default DropboxAttachmentIcon;
